const dict = {
  languageName: 'Português',
  locale: 'pt',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: 'Tema',
  'theme.light': 'Claro',
  'theme.dark': 'Escuro',
  'theme.system': 'Sistema',
  'theme.sakura': 'Sakura',

  // generic
  email: 'E-mail',
  password: 'Senha',
  ok: 'OK',
  cancel: 'Cancelar',
  retry: 'Tentar novamente',
  copy: 'Copiar',
  empty: '(sem itens)',
  loading: 'Carregando...',
  calculating: 'Calculando...',
  error: 'Erro',

  'in_development': 'Esta página está em desenvolvimento.',

  // errors
  'error.not_found': 'não encontrado',
  'error.name_conflict': 'conflito de nome',
  'error.bad_param': 'parâmetro inválido',
  'error.wrong_auth': 'autenticação incorreta',
  'error.unauthorized': 'não autorizado',
  'error.wrong_credentials': 'credenciais incorretas',
  'error.wrong_provider': 'provedor incorreto',
  'error.insufficient_privileges': 'privilégios insuficientes',
  'error.not_empty': 'não está vazio',
  'error.limit_exceeded': 'limite excedido',
  'error.already_member': 'já é membro',
  'error.not_finalized': 'não finalizado',
  'error.already_finalized': 'já finalizado',
  'error.unexpected_patch': 'patch inesperado',
  'error.timeout': 'tempo limite esgotado',
  'error.not_patch': 'não é um patch',
  'error.not_supported': 'não suportado',
  'error.unexpected_error': 'erro inesperado',

  // data sizes
  'datasize.B': 'B',
  'datasize.KiB': 'KiB',
  'datasize.MiB': 'MiB',
  'datasize.GiB': 'GiB',
  'datasize.TiB': 'TiB',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': 'Autenticação',
  'auth.dialog.please_select': 'Selecione seu provedor de conta para entrar.',
  'auth.dialog.redirecting_to': (provider) => `Redirecionando para ${provider}...`,
  'auth.dialog.remember_me': 'Lembrar de mim',
  'auth.dialog.log_in': 'Entrar',
  'auth.dialog.back': 'Voltar',
  'auth.dialog.progress_header': 'Autenticação...',
  'auth.dialog.error.header': 'Erro de autenticação',
  'auth.dialog.error.auth_not_allowed': 'Esta credencial foi proibida pelo usuário para autenticação. Use outra credencial.',
  'auth.dialog.error.unknown': 'Parâmetros de autenticação inválidos. Tente novamente.',
  'auth.dialog.error.back': 'Voltar',

  'user.profile': 'Perfil',
  'user.logout': 'Sair',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': 'Página não encontrada',
  'page_not_found.message': 'Esta página não existe.',
  'page_not_found.message2': 'Bem, na verdade ela existe, mas não há nada aqui. Aqui estão as possibilidades.',
  'page_not_found.items': [
    'Algo estava aqui antes, mas foi excluído.',
    'Algo ainda está aqui, mas você não tem acesso.',
    'Ou alguém simplesmente não teve cuidado ao copiar e colar o link.',
  ],

  'home': 'Início',
  'home.header.hint': 'Ferramentas em nuvem para desenvolvedores indie',
  'home.description': 'Kavykhi.Cloud é uma plataforma de desenvolvimento para jogos indie. Suportamos jogos para download e navegador, builds privadas e públicas, ramos (branches), equipes e muito mais.',
  'home.auth': 'Entrar ou cadastrar-se',
  'home.auth.hint': 'Criar nova conta ou entrar em uma existente',

  'projects': 'Projetos',
  'projects.hint': 'Os projetos em que você está trabalhando',
  'projects.project': (project) => `Projeto: ${project}`,
  'projects.project.hint': 'projeto',
  'projects.no_projects': 'Você ainda não tem projetos.',
  'projects.new': 'Criar projeto',
  'projects.new_dialog.header': 'Novo projeto',
  'projects.new_dialog.label': 'Nome do projeto',
  'projects.new_dialog.ok': 'Criar projeto',
  'projects.store_page': 'Página pública da loja',
  'projects.description': 'Descrição',
  'projects.branches': 'Ramos',
  'projects.versions': 'Versões',
  'projects.packages': 'Pacotes',
  'projects.management': 'Configurações do projeto',
  'projects.management.breadcrumb': 'Configurações',
  'projects.management.title': (projectTitle) => `${projectTitle} - configurações`,
  'projects.management.hint': 'configurações do projeto',
  'projects.management.users': 'Membros da equipe',
  'projects.management.users.empty': 'Nenhum membro na equipe.',
  'projects.management.users.role.tester': 'Tester',
  'projects.management.users.role.developer': 'Desenvolvedor',
  'projects.management.users.role.admin': 'Administrador',
  'projects.management.users.role.owner': 'Dono',
  'projects.management.users.role.starred': 'Favoritado',
  'projects.management.users.exile': 'Remover da equipe',
  'projects.management.users.exile.dialog.header': 'Remover da equipe',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>Tem certeza de que deseja remover {userTitle} do projeto {projectTitle}?</>,
  'projects.management.users.exile.dialog.ok': 'Remover da equipe',
  'projects.management.invites.one_time_invite': 'Link de convite de uso único',
  'projects.management.invites.one_time_invite.header': 'Link de convite de uso único',
  'projects.management.invites.one_time_invite.message': 'Link de convite de uso único:',
  'projects.management.invites.one_time_invite.note': 'Válido por 24 horas, pode ser usado uma vez.',
  'projects.management.invites.new_dialog.header': 'Link de convite',
  'projects.management.invites.new_dialog.expires': 'Expira em:',
  'projects.management.invites.new_dialog.expires.indefinite': '(sem expiração)',
  'projects.management.invites.new_dialog.approval.label': 'Usuário entra no projeto:',
  'projects.management.invites.new_dialog.approval.not_approved': 'após aprovação do admin',
  'projects.management.invites.new_dialog.approval.approved': 'imediatamente',
  'projects.management.invites.new_dialog.seats': 'Limite de entradas:',
  'projects.management.invites.new_dialog.seats.no_limit': '(sem limite)',
  'projects.management.invites.new_dialog.ok': 'Criar link de convite',
  'projects.management.deploy_sites': 'Sites de deploy',
  'projects.management.deploy_sites.empty': 'Nenhum site de deploy adicionado.',
  'projects.management.deploy_sites.add': 'Adicionar site de deploy',
  'projects.management.deploy_sites.delete': 'Excluir',
  'projects.management.deploy_sites.delete_dialog.header': 'Excluir site de deploy',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>Tem certeza de que deseja excluir o site de deploy {provider} {site}?</>,
  'projects.management.deploy_sites.delete_dialog.ok': 'Excluir site de deploy',
  'projects.management.public_access': 'Acesso público',
  'projects.management.public_access.enable': 'Ativar acesso público',
  'projects.management.public_access.enabled': <>Acesso público: <strong>permitido</strong></>,
  'projects.management.public_access.enabled.note': 'O nome e a descrição do projeto são públicos, assim como quaisquer ramos marcados como públicos.',
  'projects.management.public_access.enable_dialog.header': 'Ativar acesso público',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>Tem certeza de que deseja permitir o acesso público ao projeto {projectTitle}?<br /><br />Isso tornará as informações básicas do projeto disponíveis sem autenticação. Você precisará ativar o acesso público separadamente para cada ramo que deseja tornar público.</>,
  'projects.management.public_access.enable_dialog.ok': 'Ativar acesso público',
  'projects.management.public_access.disable': 'Desativar acesso público',
  'projects.management.public_access.disabled': <>Acesso público: <strong>não permitido</strong></>,
  'projects.management.public_access.disabled.note': 'O projeto é privado. Apenas membros da equipe do projeto podem acessá-lo.',
  'projects.management.public_access.disable_dialog.header': 'Desativar acesso público',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>Tem certeza de que deseja desativar todo o acesso público ao projeto {projectTitle}?</>,
  'projects.management.public_access.disable_dialog.ok': 'Desativar acesso público',
  'projects.management.public_access.branches': 'Ramos públicos',
  'projects.management.manage': 'Gerenciar projeto',
  'projects.rename': 'Renomear projeto',
  'projects.rename_dialog.header': 'Renomear projeto',
  'projects.rename_dialog.label': 'Nome do projeto:',
  'projects.rename_dialog.ok': 'Renomear projeto',
  'projects.edit_description': 'Editar descrição do projeto',
  'projects.edit_description_dialog.header': 'Editar descrição do projeto',
  'projects.edit_description_dialog.label': 'Descrição do projeto:',
  'projects.edit_description_dialog.ok': 'Editar descrição',
  'projects.leave': 'Sair do projeto',
  'projects.leave_dialog.header': 'Sair do projeto',
  'projects.leave_dialog.message': (projectTitle) => <>Tem certeza de que deseja sair do projeto {projectTitle}?</>,
  'projects.leave_dialog.ok': 'Sair do projeto',
  'projects.delete': 'Excluir projeto',
  'projects.delete_dialog.header': 'Excluir projeto',
  'projects.delete_dialog.message': (projectTitle) => <>Tem certeza de que deseja excluir o projeto {projectTitle}?</>,
  'projects.delete_dialog.ok': 'Excluir projeto',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle}: ${branchTitle}`,
  'branches.header.hint': 'ramo',
  'branches.no_branches': 'O projeto ainda não possui ramos',
  'branches.new': 'Criar ramo',
  'branches.new_dialog.header': 'Novo ramo',
  'branches.new_dialog.label': 'Nome do ramo',
  'branches.new_dialog.ok': 'Criar ramo',
  'branches.current_version': (version) => <>Versão atual: {version}</>,
  'branches.current_version.packages': 'Pacotes da versão atual',
  'branches.no_current_version': 'Sem versão atual',
  'branches.publish_version.new': 'Publicar nova versão',
  'branches.publish_version.existing': 'Republicar versão existente',
  'branches.version_history': 'Histórico de versões',
  'branches.version_history.empty': 'O histórico de versões do ramo está vazio.',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>A versão atual do ramo é mantida {quotaTime != null ? <>por {quotaTime}</> : <>indefinidamente</>}. Versões anteriores são mantidas por no máximo {quotaNonCurrentTime}. No máximo {plural(quotaCount, <>{quotaCountText} versão</>, <>{quotaCountText} versões</>)} no total são mantidas por ramo.</>,
  'branches.manage': 'Gerenciar ramo',
  'branches.rename': 'Renomear ramo',
  'branches.rename_dialog.header': 'Renomear ramo',
  'branches.rename_dialog.label': 'Nome do ramo:',
  'branches.rename_dialog.ok': 'Renomear ramo',
  'branches.delete': 'Excluir ramo',
  'branches.delete_dialog.header': 'Excluir ramo',
  'branches.delete_dialog.message': (branchTitle) => <>Tem certeza de que deseja excluir o ramo {branchTitle}?</>,
  'branches.delete_dialog.ok': 'Excluir ramo',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': 'versão',
  'versions.current': 'Atual',
  'versions.previous': 'Anterior',
  'versions.description': 'Descrição',
  'versions.deploy_to_site.header': 'Publicar no site',
  'versions.deploy_to_site': 'Publicar no site',
  'versions.packages': 'Pacotes',
  'versions.branches': 'Nos ramos',
  'versions.branches.publish': 'Publicar no ramo',
  'versions.branches.empty': 'A versão não foi publicada em nenhum ramo.',
  'versions.new_dialog.header': 'Nova versão',
  'versions.new_dialog.label_title': 'Versão:',
  'versions.new_dialog.label_branch': 'Ramo:',
  'versions.new_dialog.packages.header': 'Pacotes',
  'versions.new_dialog.packages.empty': 'Nenhum pacote adicionado.',
  'versions.new_dialog.packages.add': 'Adicionar pacote',
  'versions.new_dialog.packages.add_existing': 'Adicionar pacote enviado anteriormente',
  'versions.new_dialog.packages.replace': 'Substituir pacote',
  'versions.new_dialog.packages.edit': 'Editar pacote',
  'versions.new_dialog.ok': 'Criar versão',
  'versions.manage': 'Gerenciar versão',
  'versions.rename': 'Renomear versão',
  'versions.rename_dialog.header': 'Renomear versão',
  'versions.rename_dialog.label': 'Nome da versão:',
  'versions.rename_dialog.ok': 'Renomear versão',
  'versions.edit_description': 'Editar descrição da versão',
  'versions.edit_description_dialog.header': 'Editar descrição da versão',
  'versions.edit_description_dialog.label': 'Descrição da versão:',
  'versions.edit_description_dialog.ok': 'Editar descrição',
  'versions.delete': 'Excluir versão',
  'versions.delete_dialog.header': 'Excluir versão',
  'versions.delete_dialog.message': (versionTitle) => <>Tem certeza de que deseja excluir a versão {versionTitle}?</>,
  'versions.delete_dialog.ok': 'Excluir versão',

  'versions.publish_dialog.header': 'Publicar versão em um ramo',
  'versions.publish_dialog.message': (versionTitle) => <>Escolha o ramo para publicar a versão {versionTitle}.</>,
  'versions.publish_dialog.no_branches': 'Nenhum ramo no projeto.',
  'versions.publish_dialog.ok': 'Publicar versão',

  'versions.publish_existing_dialog.header': 'Republicar versão',
  'versions.publish_existing_dialog.message': 'Últimas versões:',
  'versions.publish_existing_dialog.no_versions': 'Nenhuma versão no projeto.',
  'versions.publish_existing_dialog.ok': 'Publicar versão',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle}: ${packageTitle}`,
  'packages.header.hint': 'Pacote',
  'packages.download_zip': 'Baixar como ZIP',
  'packages.download_torrent': 'Baixar torrent',
  'packages.total_size': (size) => <>Tamanho total: {size}</>,
  'packages.manage': 'Gerenciar pacote',
  'packages.rename': 'Renomear pacote',
  'packages.rename_dialog.header': 'Renomear pacote',
  'packages.rename_dialog.label': 'Nome do pacote:',
  'packages.rename_dialog.ok': 'Renomear pacote',
  'packages.edit_tags': 'Editar tags do pacote',
  'packages.edit_tags_dialog.header': 'Editar tags do pacote',
  'packages.edit_tags_dialog.message': (packageTitle) => <>Especifique as tags do pacote {packageTitle}:</>,
  'packages.edit_tags_dialog.ok': 'Definir tags do pacote',
  'packages.entrypoint': (entrypoint) => <>Arquivo inicial: {entrypoint}</>,
  'packages.entrypoint.empty': 'Arquivo inicial não definido.',
  'packages.delete': 'Excluir pacote',
  'packages.delete_dialog.header': 'Excluir pacote',
  'packages.delete_dialog.message': (packageTitle) => <>Tem certeza de que deseja excluir o pacote {packageTitle}? O pacote será excluído de todas as versões em que foi adicionado.</>,
  'packages.delete_dialog.ok': 'Excluir pacote',

  'packages.new_dialog.header': 'Novo pacote',
  'packages.new_dialog.label_title': 'Título:',
  'packages.new_dialog.title_placeholder': '(a partir das tags)',
  'packages.new_dialog.tags.header': 'Tags',
  'packages.new_dialog.files.header': 'Arquivos',
  'packages.new_dialog.total_size': (size, maximum) => <>Tamanho total: {size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(máximo {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>Tamanho dos novos dados: {size}</>,
  'packages.new_dialog.checks.empty': 'Nenhum arquivo adicionado.',
  'packages.new_dialog.checks.entrypoint.empty': 'Arquivo inicial não definido.',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>O arquivo inicial {entrypoint} não existe; talvez você tenha esquecido de adicioná-lo? Especifique um arquivo inicial existente ou deixe em branco.</>,
  'packages.new_dialog.checks.entrypoint.missing.action': 'Remover arquivo inicial',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>O arquivo inicial tem a extensão {fileExt}: sugerindo a tag {tag}.</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>Adicionar tag {tag}</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>O arquivo inicial tem a extensão {fileExt}: adicione a tag {tag} para tornar o pacote jogável no navegador.</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>O arquivo inicial tem a extensão {fileExt}: isso é um erro? Geralmente não é um tipo de arquivo que pode ser iniciado.</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>O arquivo inicial tem a extensão {fileExt}: é recomendado incluir os arquivos de conteúdo reais em vez de compactá-los em um arquivo de arquivo.</>,
  'packages.new_dialog.checks.entrypoint.executable': 'O arquivo inicial não está marcado como executável',
  'packages.new_dialog.checks.entrypoint.executable.action': 'Marcar como executável',
  'packages.new_dialog.checks.single_root_dir': 'Recomenda-se colocar os arquivos diretamente na raiz, em vez de ter uma única pasta na raiz.',
  'packages.new_dialog.checks.single_root_dir.action': 'Substituir pasta pelo seu conteúdo',

  'packages.add_existing_dialog.header': 'Adicionar pacote',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `Adicionar ${plural(packagesCount, `${packagesCount} pacote`, `${packagesCount} pacotes`)}` : 'Nenhum pacote selecionado',
  'packages.add_existing_dialog.message': 'Últimos pacotes enviados:',
  'packages.add_existing_dialog.no_packages': 'Nenhum pacote enviado recentemente.',

  'packages.launch': 'Iniciar',

  'packages.install': 'Instalar',
  'packages.install_dialog.header': 'Instalar',
  'packages.install_dialog.workdir.label': 'Diretório de trabalho:',
  'packages.install_dialog.workdir.value.new': '(criar novo)',
  'packages.install_dialog.workspace.label': 'Criar pasta em:',
  'packages.install_dialog.workspace.placeholder': '(selecionar pasta raiz)',
  'packages.install_dialog.ok': 'Instalar',

  'packages.update': 'Atualizar',

  'packages.upload.status.existing': 'Da versão anterior',
  'packages.upload.status.queued': 'Na fila',
  'packages.upload.status.packing': 'Compactando...',
  'packages.upload.status.creating': 'Criando...',
  'packages.upload.status.create_retrying': 'Falha ao criar, aguardando e tentando novamente',
  'packages.upload.status.splitting': 'Dividindo...',
  'packages.upload.status.uploading': 'Enviando...',
  'packages.upload.status.finalizing': 'Finalizando...',
  'packages.upload.status.finalize_retrying': 'Falha ao finalizar, aguardando e tentando novamente',
  'packages.upload.status.resolving': 'Resolvendo patch...',
  'packages.upload.status.resolve_retrying': 'Falha ao resolver patch, aguardando e tentando novamente...',
  'packages.upload.status.done': 'Enviado com sucesso',
  'packages.upload.status.errored': 'Erro',

  'packages.upload.part.status.queued': 'Na fila',
  'packages.upload.part.status.hashing': 'Calculando hash',
  'packages.upload.part.status.upload_queued': 'Envio na fila',
  'packages.upload.part.status.uploading': 'Enviando',
  'packages.upload.part.status.upload_retrying': 'Erro, tentando enviar novamente',
  'packages.upload.part.status.upload_finalizing': 'Finalizando envio',
  'packages.upload.part.status.upload_errored': 'Erro',
  'packages.upload.part.status.done': 'Enviado',

  'packages.play': 'Jogar no navegador',
  'packages.play.reset': 'Reiniciar',
  'packages.play.fullscreen': 'Tela cheia',

  'deploy_sites.add_dialog.header': 'Adicionar site de deploy',
  'deploy_sites.add_dialog.message': (projectTitle) => <>Escolha a credencial de deploy e insira a URL do site para salvá-los como um site de deploy para o projeto {projectTitle}.</>,
  'deploy_sites.add_dialog.label_credential': 'Credencial de deploy:',
  'deploy_sites.add_dialog.select_credential': 'Selecionar credencial',
  'deploy_sites.add_dialog.select_credential.new': 'Adicionar nova credencial...',
  'deploy_sites.add_dialog.label_select_site': 'Selecionar site:',
  'deploy_sites.add_dialog.select_credential_first': '(selecione a credencial primeiro)',
  'deploy_sites.add_dialog.select_site': '(selecionar site)',
  'deploy_sites.add_dialog.label_enter_site': 'Ou insira a URL do site:',
  'deploy_sites.add_dialog.ok': 'Adicionar site',

  'deploy_to_site_dialog.header': 'Publicar no site',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>Escolha o site para publicar a versão {versionTitle} de {projectTitle}.</>,
  'deploy_to_site_dialog.label_site': 'Publicar no site:',
  'deploy_to_site_dialog.select_site': 'Selecionar site',
  'deploy_to_site_dialog.select_site.new': 'Adicionar novo site de deploy...',
  'deploy_to_site_dialog.packages.message.itch': <>Os pacotes serão publicados no itch.io usando o <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a>. Os nomes dos canais são derivados das tags do pacote.</>,
  'deploy_to_site_dialog.deploy': 'Publicar',
  'deploy_to_site_dialog.close': 'Fechar',
  'deploy_to_site_dialog.error.no_packages': 'Nenhum pacote para publicar.',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>Não é possível publicar múltiplos pacotes em um único canal. Atualmente, {plural(packagesCount, <>{packagesCountText} pacote está</>, <>{packagesCountText} pacotes estão</>)} configurados para publicar no canal {channel}.</>,
  'deploy_to_site_dialog.job.queued': 'Na fila',
  'deploy_to_site_dialog.job.downloading': 'Baixando...',
  'deploy_to_site_dialog.job.unpacking': 'Descompactando...',
  'deploy_to_site_dialog.job.uploading': 'Publicando...',
  'deploy_to_site_dialog.job.succeeded': 'Sucesso',
  'deploy_to_site_dialog.job.errored': 'Erro',

  'store': 'Loja',
  'store.hint': 'Projetos públicos',
  'store.project.hint': 'Página do projeto na loja',
  'store.project.owner': 'Desenvolvedor',
  'store.project.description': 'Descrição',
  'store.project.star': 'Favoritar',
  'store.project.starred': 'Favoritado',
  'store.project.content': 'Conteúdo',
  'store.project.content.warning': 'O conteúdo foi fornecido por um desenvolvedor terceirizado.',
  'store.project.branch_version': (branchTitle, versionTitle) => `Ramo ${branchTitle}: versão ${versionTitle}`,
  'store.project.branch_version.published': (branchVersionPublished) => `Publicado: ${branchVersionPublished}`,

  'me': 'Perfil',
  'me.hint': 'Configurações de perfil e credenciais vinculadas',
  'me.rename': 'Renomear perfil',
  'me.rename_dialog.header': 'Renomear perfil',
  'me.rename_dialog.label_title': 'Nome:',
  'me.rename_dialog.ok': 'Renomear perfil',
  'me.credentials': 'Credenciais',
  'me.credentials.hint.auth_allowed': 'Qualquer uma destas credenciais pode ser usada para entrar nesta conta.',
  'me.credentials.hint.auth_disallowed': 'Estas credenciais estão vinculadas à sua conta, mas não podem ser usadas para entrar.',
  'me.credentials.empty': 'Nenhuma credencial.',
  'me.credentials.empty.auth_allowed.warning': 'Você pode perder o acesso à sua conta! Você não vinculou nenhuma credencial para entrar. Vincule uma credencial de login o mais rápido possível.',
  'me.credentials.profile_picture.alt': (provider) => `Foto de perfil do ${dict[`auth.provider.${provider}`]}`,
  'me.credentials.created': (created) => <>adicionado em {created}</>,
  'me.credentials.last_used': (lastUsed) => <>último uso em {lastUsed}</>,
  'me.credential.unlink': 'Desvincular',
  'me.credential.allow_auth': 'Permitir login',
  'me.credential.disallow_auth': 'Proibir login',
  'me.credential.display_publicly': 'Exibir publicamente',
  'me.credential.dont_display_publicly': 'Não exibir publicamente',
  'me.credential.link': 'Vincular credencial',
  'me.credential.link_dialog.header': 'Vincular credencial',
  'me.credential.link_dialog.message': 'Selecione o provedor de conta para vincular.',
  'me.credential.unlink_dialog.header': 'Desvincular credencial',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>Tem certeza de que deseja desvincular a conta do {credentialProvider} ({credentialTitle}) da sua conta Kavykhi.Cloud?</>,
  'me.credential.unlink_dialog.ok': 'Desvincular credencial',
  'me.sessions': 'Sessões',
  'me.sessions.hint': 'Esta é uma lista das suas sessões ativas, incluindo o navegador atual.',
  'me.sessions.started': (started) => <>iniciada em <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>ativa em <span class="value">{lastAuth}</span></>,
  'me.sessions.current': 'Sessão atual',
  'me.sessions.empty': 'Nenhuma sessão.',
  'me.sessions.delete': 'Encerrar',
  'me.sessions.delete_dialog.header': 'Encerrar sessão',
  'me.sessions.delete_dialog.message': 'Tem certeza de que deseja encerrar esta sessão?',
  'me.sessions.delete_dialog.ok': 'Encerrar sessão',
  'me.api_tokens': 'Tokens de API',
  'me.api_tokens.hint': 'Tokens de API podem ser criados aqui para uso em automação.',
  'me.api_tokens.started': (started) => <>criado em <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>expira em <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': 'sem expiração',
  'me.api_tokens.empty': 'Nenhum token de API.',
  'me.api_tokens.create': 'Gerar token de API',
  'me.api_tokens.create_dialog.header': 'Gerar token de API',
  'me.api_tokens.create_dialog.message': 'Token de API gerado:',
  'me.api_tokens.create_dialog.note': 'O token não será exibido novamente, salve-o com segurança.',
  'me.api_tokens.delete': 'Excluir',
  'me.api_tokens.delete_dialog.header': 'Excluir token de API',
  'me.api_tokens.delete_dialog.message': 'Tem certeza de que deseja excluir este token?',
  'me.api_tokens.delete_dialog.ok': 'Excluir token de API',
  'me.deploy_credentials': 'Credenciais de deploy',
  'me.deploy_credentials.hint': 'Credenciais para publicação em plataformas externas podem ser adicionadas aqui.',
  'me.deploy_credentials.empty': 'Nenhuma credencial de deploy adicionada.',
  'me.deploy_credential.add': 'Adicionar credencial de deploy',
  'me.deploy_credential.add_dialog.header': 'Adicionar credencial de deploy',
  'me.deploy_credential.add_dialog.label_site': 'Site:',
  'me.deploy_credential.add_dialog.label_title': 'Nota:',
  'me.deploy_credential.add_dialog.label_key': 'Chave:',
  'me.deploy_credential.add_dialog.default_title': (date) => `Chave ${date}`,
  'me.deploy_credential.add_dialog.ok': 'Adicionar credencial de deploy',
  'me.deploy_credential.add_dialog.hint.itch': <>Para gerar a chave de API do itch.io, acesse as <a href="https://itch.io/user/settings/api-keys" target="_blank">configurações do seu perfil</a> no itch.io. Você pode usar uma chave existente com origem "web" ou "wharf". Chaves com origem "Kavykhi.Cloud" não funcionarão.</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>Não oferecemos suporte para adicionar credenciais do {credentialProvider} no momento.</>,
  'me.deploy_credential.delete': 'Excluir',
  'me.deploy_credential.delete_dialog.header': 'Excluir credencial de deploy',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>Tem certeza de que deseja excluir a credencial {credentialTitle} do {credentialProvider}? Quaisquer sites de deploy configurados com esta credencial também serão removidos do projeto.</>,
  'me.deploy_credential.delete_dialog.ok': 'Excluir credencial',
  'me.public_profile': 'Perfil público',
  'me.public_profile.public_credentials': 'Credenciais públicas',
  'me.public_profile.public_credentials.hint': 'Selecione as credenciais para exibir publicamente.',
  'me.manage': 'Gerenciar conta',
  'me.delete': 'Excluir conta',
  'me.delete.dialog.header': 'Excluir conta',
  'me.delete.dialog.message': (userTitle) => <>Tem certeza de que deseja excluir permanentemente sua conta Kavykhi.Cloud ({userTitle})?</>,
  'me.delete.dialog.ok': 'Excluir conta',

  'invite': 'Convite',
  'invite.hint': 'Convite de projeto',
  'invite.message.already_member': (projectTitle) => <>Você já é membro do projeto {projectTitle}.</>,
  'invite.message.join': (projectTitle) => <>Você foi convidado para o projeto {projectTitle}.</>,
  'invite.join': 'Entrar no projeto',

  'local': 'Conteúdo local',
  'local.hint': 'Conteúdo instalado localmente',
  'local.workdirs': 'Pacotes instalados',
  'local.workdirs.empty': 'Nenhum pacote instalado.',
  'local.workdir.action.launch': 'Iniciar',
  'local.workdir.action.repair': 'Reparar',
  'local.workdir.action.delete': 'Desinstalar',
  'local.workdir.delete_dialog.header': 'Desinstalar pacote',
  'local.workdir.delete_dialog.message': (packageTitle) => <>Tem certeza de que deseja desinstalar o pacote {packageTitle} do seu dispositivo?</>,
  'local.workdir.delete_dialog.ok': 'Desinstalar',
  'local.workspaces': 'Pastas raiz',
  'local.app_not_detected.message': 'O aplicativo local Kavykhi.Cloud não foi detectado. Baixe e instale-o usando um dos links abaixo. Se já estiver instalado, certifique-se de que está em execução.',

  'local_app.detected': 'Conteúdo local',

  'error_dialog.header': 'Erro',
  'error_dialog.messageFunc': (e) => `Erro: ${dict[`error.${e}`] ?? e}.`,

  'upload_box.choose_files': 'Selecionar arquivos',
  'upload_box.choose_directories': 'Selecionar pastas',
  'upload_box.add.progress_dialog.header': 'Adicionando arquivos',
  'upload_box.add.progress_dialog.message': 'Processando arquivos...',
  'upload_box.delete': (itemsCount) => `Excluir ${plural(itemsCount, `${itemsCount} item`, `${itemsCount} itens`)}`,
  'upload_box.start_upload': 'Iniciar envio',
  'upload_box.drop_area.message': 'Arraste arquivos e pastas aqui',
  'upload_box.drop_area.box_dropping_message': 'Solte aqui para colocar na raiz',
  'upload_box.entry.explode_folder': 'Substituir pasta pelo seu conteúdo',
  'upload_box.entry.set_entrypoint': 'Definir arquivo inicial',
  'upload_box.entry.mark_executable': 'Marcar como executável',
  'upload_box.entry.unmark_executable': 'Desmarcar como executável',
  'upload_box.entry.remove': 'Remover',

  'package.tags.empty': '(sem tags)',
  'package.tag.os': 'SO',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': 'Arq',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': 'Bits',
  'package.tag.bits:64': '64-bit',
  'package.tag.bits:32': '32-bit',
  'package.tag.packaging': 'Empacotamento',
  'package.tag.packaging:installer': 'Instalador',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': 'Componente',
  'package.tag.component:client': 'Cliente',
  'package.tag.component:server': 'Servidor',
  'package.tag.runtime': 'Runtime',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Distribuição Linux',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': 'Docs',
  'docs.page_no_language': 'Não disponível neste idioma',
  'docs.page_no_language.message': 'Outras versões deste documento disponíveis:',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': 'Denunciar conteúdo',
  'report_content.dialog.header': 'Denunciar conteúdo',
  'report_content.dialog.link': 'Enviar denúncia por e-mail',
  'report_content.dialog.message': (email, link) => <>Clique no link para enviar sua denúncia:<br /><br />{link}<br /><br />Ou envie um e-mail manualmente para {email}</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
